export default "__VITE_ASSET__CSVLyBE1__"